import React, { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext({ lang: "fr", setLang: () => {}, t: (fr) => fr });

const initialLang = () => {
    const saved = localStorage.getItem("kz_lang");
    if (saved === "fr" || saved === "en") return saved;
    return (navigator.language || "fr").toLowerCase().startsWith("en") ? "en" : "fr";
};

export function LangProvider({ children }) {
    const [lang, setLangState] = useState(initialLang);
    const setLang = (l) => {
        localStorage.setItem("kz_lang", l);
        setLangState(l);
    };
    useEffect(() => {
        document.documentElement.lang = lang;
        document.title = lang === "en" ? "Kazem Logistics — Transport organiser" : "Kazem Logistics — Organisateur de transport";
    }, [lang]);
    const t = (fr, en) => (lang === "en" ? en : fr);
    return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
